import { Http } from '@/services';
import { baseStates, baseMutations, baseActions, baseGetters } from '@/stores/base';

export const myAccountMessage = {

    namespaced: true,

    state:
    {
        ...baseStates,

        url: '',
        
        moreLoading: false,
    },

    mutations:
    {
        ...baseMutations,

        append: (state, items) =>
        {
            state.items = [...state.items, ...items.data];
        },
    },

    actions:
    {
        ...baseActions,

        loadMore: async ({commit}, url) => 
        {
            commit('setLoading', { action: 'more', boolean: true });

            let response = await Http.get(url);
            
            commit('setLoading', { action: 'more', boolean: false });

            if (response.status === 200) commit('appendBulk', response.data);

            return response;
        },
    },

    getters:
    {
        ...baseGetters,
    },
};



// WEBPACK FOOTER //
// ./src/views/my-account/content/chats/view/store.js